$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * nav
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
        $(".js-nav").toggleClass("active");
        $("body").toggleClass("freeze");
        $(".js-header").toggleClass("navOpen");
    
        if ($(".js-nav").hasClass("active")) {
            $(".js-nav").removeAttr("inert").focus();
            $(".js-nav a").attr("tabindex", "0");
            $(".js-nav li.parent ul a").attr("tabindex", "-1");
        } else {
            $(".js-nav").attr("inert", "");
            $(".js-nav a").attr("tabindex", "-1");
        }
    });
    
    
    $(".js-nav li.parent")
        .attr("tabindex", "0") // Make it focusable
        .on("click keydown", function (event) {
            if (event.type === "keydown" && event.key !== "Enter") {
                return; // Ignore non-Enter key presses
            }

            let targetLink = $(event.target).closest("a");
    
            if (targetLink.length) {
                return; // Do nothing if a link inside is clicked/entered
            }
    
            if ($(this).hasClass("open")) {
                $(this).removeClass("open").find("ul a").attr("tabindex", "-1");
            } else if ($(this).hasClass("active")) {
                $(this).removeClass("active").find("ul a").attr("tabindex", "-1");
            } else {
                $(".js-nav li.parent").removeClass("active open");
                $(this).addClass("open").find("ul a").attr("tabindex", "0");
            }
        });
    
    $(".js-nav li li.active").parents(".parent").addClass("active");
    
    $(".js-nav-exit").on("focusout", function () {
        $(".js-navbutton").trigger("click");
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navSub
    // *
    // *
    $(".js-navsubbutton").click(function(event) {
        if (event.target === this) {
            $(this).find(".js-navsub").toggleClass("active");
          }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $carouselImage = $(".js-carouselimage");

    if ($carouselImage.length) {
        $carouselImage.each(function () {
            $(this).slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: false,
                speed: 1000,
                waitForAnimate: true,
                dots: false,
                pauseOnHover: false,
                slidesToShow: 3,
                prevArrow: $(this).siblings(".js-carouselimage-prev"),
                nextArrow: $(this).siblings(".js-carouselimage-next"),
                responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 2,
                      }
                    },
                    {
                      breakpoint: 800,
                      settings: {
                        slidesToShow: 1,
                      }
                    }
                  ]
            });
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-item").click(function (event) {
        if ($(event.target).is('a') || $(event.target).closest('a').length) {
            // If it's a link, let the default link behavior happen
            return;
        }

        const $this = $(this);
        const $header = $this.find(".js-accordion-header");
        const $content = $this.find(".js-accordion-content");

        // Close other accordion items
        $this.siblings(".js-accordion-item").each(function() {
            const $siblingHeader = $(this).find(".js-accordion-header");
            const $siblingContent = $(this).find(".js-accordion-content");
            $(this).removeClass("active");
            $siblingContent.slideUp();
            $siblingHeader.attr("aria-expanded", "false"); // Update aria-expanded for closed items
        });

        // Toggle current accordion item
        const isActive = $this.hasClass("active");
        $this.toggleClass("active");
        $content.slideToggle();

        // Update aria-expanded based on toggle state
        if (isActive) {
            $header.attr("aria-expanded", "false");
        } else {
            $header.attr("aria-expanded", "true");
        }
    });

    $(".js-accordion-openfirst .js-accordion-item:first-child").trigger("click");

    // open accordion with anchor link
    let hash = window.location.hash.split('#')[1];
    if ($("#" + hash).hasClass("js-accordion-item") && !$("#" + hash).hasClass("open")) {
        $("#" + hash).find(".js-accordion").click();
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * searchFilter
    // *
    // *
    $(".js-searchfilter-button").click(function(event) {
        var $button = $(this);
        var $filterContent = $button.closest(".js-searchfilter").find(".js-searchfilter-filter");
        $button.toggleClass("active");
        var isCurrentlyExpanded = $button.attr("aria-expanded") === "true";
        var newExpandedState = !isCurrentlyExpanded;
        $button.attr("aria-expanded", newExpandedState);
        $filterContent.attr("aria-hidden", !newExpandedState); // or isCurrentlyExpanded
        $filterContent.slideToggle();
    });

    $(".js-searchfilter-form").on("submit", function(e){
        e.preventDefault();

        // Formulardaten als Query-String sammeln
        var formData = $(this).serialize();

        // Aktuelle URL ohne GET-Parameter
        var baseUrl = window.location.origin + window.location.pathname;

        // Vollständige URL mit GET-Parametern
        var fullUrl = baseUrl + '?' + formData;

        $.get(fullUrl).done(function(data){
            $(".js-joblist").html($(data).find(".js-joblist").html());
        });

        // alle filter schließen
        $(".js-searchfilter-button.active").trigger("click");
    });

    // click pagination
    $(document).on("click", ".js-joblist-pagination", function(e){
        e.preventDefault();

        var url = $(this).attr("href");

        $.get(url).done(function(data){
            $(".js-joblist").html($(data).find(".js-joblist").html());
        });

        $('html, body').animate({
            scrollTop: $("#joblist").offset().top
        }, 1000);
    });

});



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("sticky");
    } else {
        $(".js-header").removeClass("sticky");
    }
});
